<div class="route-bar">
  <div class="route-bar-breadcrumb">
    <a routerLink="/">
      <i class="pi pi-home"></i>
    </a>
    <span class="mx-1">/</span>
    @for (item of items; track item; let last = $last) {
      @if (item.routerLink) {
        <a [routerLink]="item.routerLink">{{item.label}}</a>
      }
      @if (!item.routerLink) {
        {{item.label}}
      }
      @if (!last) {
        <span class="mx-1">/</span>
      }
    }
  </div>
</div>